import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07ebaeb1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block" }
const _hoisted_2 = { class: "bi-tmpl-detail" }
const _hoisted_3 = { class: "bi-tmpl-detail__left" }
const _hoisted_4 = { class: "bi-tmpl-detail__left__header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"600"} }, "分析模块", -1))
const _hoisted_6 = { class: "bi-tmpl-detail__left__box" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "bi-tmpl-detail__left__item__content__headline" }
const _hoisted_9 = { style: {"margin-right":"9px","height":"20px"} }
const _hoisted_10 = { class: "bi-tmpl-detail__left__switch" }
const _hoisted_11 = {
  key: 0,
  class: "bi-tmpl-detail__left__item__content__child"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "bi-tmpl-detail__right" }
const _hoisted_14 = { style: {"width":"100%","height":"100%","position":"absolute","left":"0","top":"0"} }
const _hoisted_15 = { class: "bi-tmpl-detail__right__header" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"600","margin-left":"24px"} }, "模板编辑", -1))
const _hoisted_17 = { class: "bi-tmpl-detail__right__header-operate" }
const _hoisted_18 = {
  key: 0,
  style: {"margin-left":"12px"}
}

import { computed, ref, nextTick } from 'vue';

import {
  BaseSelect,
  BaseSwitch,
  BaseInput,
  BaseButton,
  XrkMessage,
  createDialog,
  BaseScrollbar
} from 'xrk-components';
import BiTmplDetailForm from '@V/bi-tmpl/src/components/bi-tmpl-detail/bi-tmpl-detail-form.vue';

import * as BiTemplDetail from '../components/bi-tmpl-detail';

import { ModelType, SCENE_MAPPING } from '../constants';

import { useBiTmplDetailSteup } from '../store';
import { storeToRefs } from 'pinia';

import { useRouter } from 'vue-router';

import usePreview from '../hooks/use-preview';

import { checkValueDone, useRouteQuery } from '../hooks';

const DEFAULT_MENU_TYPE = '101'; //  默认激活菜单

export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail',
  setup(__props) {

const NO_VISIBLE = ['101', '102']; // 不显示【展示】，默认必展示
const NO_SETTING = ['8', '9']; // 不展示【设置】，没有可设置内容

const router = useRouter();

const store = useBiTmplDetailSteup();
const { state } = storeToRefs(store);

const { onPreview } = usePreview();
const { query, isCheck } = useRouteQuery();

const rightBox = ref(null);
const cmpName = computed(() => {
  return BiTemplDetail['BiTmplDetail_' + state.value.activeMenu[0]];
});
const settingText = key => {
  return menuClassNameDone(key) ? '已设置' : '未设置';
};

/**
 * @description: 检测上一个菜单是否设置完成
 * @param {*} curKey
 * @return {boolean} true已完成
 */
const preValueDone = curKey => {
  let _curKey = curKey;
  const arrMenu: any = Array.from(state.value.menuValue).reduce(
    (arr: any[], item) => {
      if (item[1]?.defaultChildKey) {
        if (_curKey === item[0]) _curKey = item[1].defaultChildKey;

        arr = [
          ...arr,
          ...Object.entries(state.value.menuValue.get(item[0]).value)
        ];
      } else {
        arr.push(item);
      }
      return arr;
    },
    []
  );

  const curArrMenuIndex = arrMenu.findIndex(item => item[0] === _curKey);
  // 从第一个之后开始校验
  if (curArrMenuIndex) {
    const [preKey, preMenu] = arrMenu[curArrMenuIndex - 1];
    // 这两个不需要设置，让它俩下一个以热力图开始校验，偷懒，直接写死16
    if (NO_SETTING.includes(preKey)) {
      const _index = arrMenu.findIndex(
        item => item[0] === NO_SETTING[state.value.menuValue.get('8') ? 0 : 1]
      );
      const [, _preMenu] = arrMenu[_index - 1];
      return Boolean(checkValueDone(_preMenu));
    }
    return Boolean(checkValueDone(preMenu));
  }
  return true;
};
// 激活菜单样式
const menuClassNameActive = menuType => {
  return +state.value.activeMenu[0] === +menuType
    ? 'bi-tmpl-detail__left__item__content--active'
    : '';
};

// 激活菜单按钮样式
const menuIconClassNameActive = menuType => {
  return +state.value.activeMenu[0] === +menuType
    ? 'bi-tmpl-detail__left__item__icon--active'
    : 'bi-tmpl-detail__left__item__icon--default';
};

// 设置完毕菜单样式
const menuClassNameDone = menuType => {
  const curMenu = state.value.menuValue.get(menuType);
  return checkValueDone(curMenu) === 1
    ? 'bi-tmpl-detail__left__setting--done'
    : '';
};
// 是否显示菜单【已设置】标签
const showSettingTag = key => {
  if (NO_SETTING.includes(key)) return false;
  return true;
};
// 是否显示菜单【展示】
const showVisible = key => {
  if (NO_VISIBLE.includes(key)) return false;
  return true;
};
// 切换菜单，上一个设置完毕才可切换下一个
const onChangeMenu = async (parentKey, childKey?) => {
  const curKey = childKey || parentKey;
  const menuLevel = childKey ? 1 : 0;
  const curParentMenu = state.value.menuValue.get(parentKey);
  if (!preValueDone(curKey)) {
    XrkMessage.error('请完成上一个模块设置');
    return Promise.reject('请完成上一个模块设置');
  }
  if (curParentMenu.defaultChildKey) {
    store.setActiveMenu(parentKey, 0);
    if (!childKey) {
      // 有子集的，但是没有传子集key，取默认子集
      store.setActiveMenu(curParentMenu.defaultChildKey, 1);
    } else {
      store.setActiveMenu(curKey, menuLevel);
    }
  } else {
    store.setActiveMenu(curKey, menuLevel);
  }

  // 切换菜单后，右侧置顶
  rightBox.value && rightBox.value.scrollTo(0, 0);

  nextTick(() => {
    const el = document.querySelector('.bi-tmpl-detail__right__box');
    el?.scrollIntoView({
      block: 'start',
      inline: 'start'
    });
  });
};

// 是否展示
const onChangeSwitch = async ({ item, key, cKey, value }) => {
  // 校验并选择菜单
  await onChangeMenu(key, cKey);

  //设置子项是否展示
  if (cKey) {
    store.setMenuShow(item, value, cKey);
    //子项勾选父级自动勾上，子项没了父级也取消
    const hasShowKey = Object.keys(item.value).some(
      key => item.value[key].show
    );
    store.setMenuShow(item, hasShowKey);
  } else {
    //设置父项是否展示
    store.setMenuShow(item, value);
    //判断是否有子项
    if (item.renderChild || typeof item.value === 'object') {
      //有子项的菜单 父级变更子项联动
      Object.keys(item.value).forEach(cKey => {
        store.setMenuShow(item, value, cKey);
      });
    }
  }
};
const onChangeScene = v => {
  state.value.sceneType = v;
  onChangeMenu(DEFAULT_MENU_TYPE);

  nextTick(() => {
    const el = document.querySelectorAll('.bi-tmpl-detail__left__item');
    el?.[0]?.scrollIntoView({
      block: 'start',
      inline: 'start',
      behavior: 'smooth'
    });
  });
};

const onCancel = ref<(skip?: boolean) => void>(() => {
  router.replace({
    name: 'bi-tmpl-list'
  });
});
const onSave = async () => {
  await store.saveTmpl();
  await XrkMessage.success('保存成功');
  onCancel.value(true);
};

const initData = async () => {
  await store.initTmpl(query.id, query?.sceneType);

  const getValueString = () => {
    const res = {
      __type: state.value.sceneType,
      __name: state.value.templateName
    };
    state.value.menuValue.forEach((value, key) => {
      res[key] = JSON.stringify(value);
    });
    return JSON.stringify(res);
  };
  const oldValue = getValueString();
  onCancel.value = (skip: boolean) => {
    if (skip || oldValue === getValueString()) {
      router.replace({
        name: 'bi-tmpl-list'
      });
      return;
    }
    createDialog({
      width: 480,
      center: true,
      title: '提示',
      content: 'BI模板还未保存，退出后已配置内容将不会保存，是否现在退出？',
      confirmBtnConfig: { content: '立即退出', type: 'primary', show: true },
      cancelBtnConfig: { content: '暂不退出', type: 'default', show: true },
      beforeConfirm: done => {
        router.replace({
          name: 'bi-tmpl-list'
        });
        done();
      }
    });
  };
};

initData();
onChangeMenu(DEFAULT_MENU_TYPE);

return (_ctx: any,_cache: any) => {
  const _component_base_svg = _resolveComponent("base-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_unref(BaseSelect), {
            style: {"width":"200px"},
            placeholder: "请选择场景",
            disabled: _unref(isCheck),
            options: 
              Object.values(_unref(SCENE_MAPPING)).sort((a, b) => a.sort - b.sort)
            ,
            "model-value": _unref(state).sceneType,
            onChange: onChangeScene
          }, null, 8, ["disabled", "options", "model-value"])
        ]),
        _createVNode(_unref(BaseScrollbar), {
          style: {"height":"calc(100% - 66px)"},
          always: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).menuValue, ([key, item], index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "bi-tmpl-detail__left__item pointer",
                  key: key,
                  style: _normalizeStyle({
                cursor: !item.renderChild ? 'pointer' : '',
                paddingTop: index === 0 ? '24px' : '16px'
              }),
                  onClick: _withModifiers(($event: any) => (onChangeMenu(key, item.defaultChildKey)), ["stop"])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass([
                  'bi-tmpl-detail__left__item__content',
                  menuClassNameActive(key),
                  'pointer'
                ])
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["bi-tmpl-detail__left__text", {
                      'bi-tmpl-detail__left__text__tip': +key === 18
                    }])
                      }, [
                        _createElementVNode("span", _hoisted_9, [
                          _createVNode(_component_base_svg, {
                            iconClass: item.iconName,
                            className: menuIconClassNameActive(key)
                          }, null, 8, ["iconClass", "className"])
                        ]),
                        _createElementVNode("span", null, _toDisplayString(item.title), 1)
                      ], 2),
                      _createElementVNode("div", _hoisted_10, [
                        (showVisible(key))
                          ? (_openBlock(), _createBlock(_unref(BaseSwitch), {
                              key: 0,
                              size: "small",
                              "model-value": item.show,
                              activeValue: true,
                              activeText: item.show ? '展示' : '不展示',
                              inactiveValue: false,
                              disabled: !preValueDone(key) || _unref(isCheck),
                              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                              onChange: 
                        e =>
                          onChangeSwitch({
                            item,
                            key,
                            cKey: null,
                            value: e
                          })
                      
                            }, null, 8, ["model-value", "activeText", "disabled", "onChange"]))
                          : _createCommentVNode("", true),
                        (showSettingTag(key))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass([
                        menuClassNameDone(key),
                        'bi-tmpl-detail__left__setting'
                      ])
                            }, _toDisplayString(settingText(key)), 3))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (item.renderChild)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value, (cItem, cKey) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "bi-tmpl-detail__left__item__content__child__item",
                              key: cKey,
                              onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              _createElementVNode("span", {
                                onClick: _withModifiers(($event: any) => (onChangeMenu(key, cKey)), ["stop"]),
                                style: _normalizeStyle({
                        color:
                          _unref(state).activeMenu[1] === cKey ? '#fa8100' : '#4c4c4c',
                        cursor: 'pointer'
                      })
                              }, _toDisplayString((cItem as any).title), 13, _hoisted_12),
                              _createVNode(_unref(BaseSwitch), {
                                style: {"flex-shrink":"0","margin-left":"6px"},
                                size: "small",
                                "model-value": (cItem as any).show,
                                activeText: item.show ? '展示' : '不展示',
                                disabled: !preValueDone(cKey) || _unref(isCheck),
                                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                                onChange: 
                        e =>
                          onChangeSwitch({
                            item,
                            key,
                            cKey,
                            value: e
                          })
                      
                              }, null, 8, ["model-value", "activeText", "disabled", "onChange"])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ], 2)
                ], 12, _hoisted_7))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_unref(BaseInput), {
                class: "bi-input",
                style: {"width":"248px"},
                placeholder: "请输入模板名称",
                modelValue: _unref(state).templateName,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).templateName) = $event)),
                maxlength: 20,
                disabled: _unref(isCheck)
              }, null, 8, ["modelValue", "disabled"]),
              _createVNode(_unref(BaseButton), {
                style: {"margin-left":"12px"},
                type: "default",
                onClick: _cache[4] || (_cache[4] = () => onCancel.value())
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 返回 ")
                ]),
                _: 1
              }),
              (!_unref(isCheck))
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createVNode(_unref(BaseButton), {
                      type: "default",
                      onClick: _unref(onPreview),
                      disabled: !_unref(state).menuValue.get(_unref(ModelType)['COVER']).value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 预览 ")
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"]),
                    _createVNode(_unref(BaseButton), { click: onSave }, {
                      default: _withCtx(() => [
                        _createTextVNode("保存")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_unref(BaseScrollbar), {
            style: {"height":"calc(100% - 66px)"},
            always: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "bi-tmpl-detail__right__box",
                ref_key: "rightBox",
                ref: rightBox
              }, [
                _createVNode(BiTmplDetailForm, null, {
                  default: _withCtx(({ disabled }) => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(cmpName.value), { disabled: disabled }, null, 8, ["disabled"]))
                  ]),
                  _: 1
                })
              ], 512)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})